import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Level2 = function Level2(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor;
  return /*#__PURE__*/_jsxs("svg", {
    className: className,
    viewBox: "0 0 18 17",
    width: 1 * size,
    height: size,
    children: [/*#__PURE__*/_jsx("rect", {
      x: 0.178,
      y: 7.063,
      width: 3.133,
      height: 9.504,
      rx: 1.567,
      fill: !ignoreColor ? color : undefined
    }), /*#__PURE__*/_jsx("path", {
      d: "M7.173 5.461a1.567 1.567 0 1 1 3.133 0v9.54a1.567 1.567 0 1 1-3.133 0V5.46zM14.168 2.293a1.567 1.567 0 1 1 3.134 0V15a1.567 1.567 0 0 1-3.133 0V2.293z",
      fill: !ignoreColor ? color : undefined
    })]
  });
};
export default Level2;